import { Main } from "./main";
import "styles/video-player.css";

export const VideoPlayer = () => {
  return (
    <>
      <Main />
    </>
  );
};
